import React, { FC } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UserIcon from "../../static/svg/UserIcon";
import DetailsIcon from "../../static/svg/DetailsIcon";
import MainLayout from "../../Layouts/MainLayout";
import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import AgentsCrewsIcon from "../../static/svg/AgentsCrewsIcon";
import FrequencyCrewIcon from "../../static/svg/FrequencyCrewIcon";
import FlowsCrewIcon from "../../static/svg/FlowsCrewIcon";
import LogsIcon from "../../static/svg/LogsIcon";
import HoldersIcon from "../../static/svg/HoldersIcon";
import FinetureTile from "../../static/svg/FinetureTile";

const SpaceConfig: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const handleClick = (path: string | null) => {
    if (path) {
      navigate(path);
    }
  };

  const tiles = [
    {
      name: "Users",
      path: `/user-page/space/${id}`,
      icon: UserIcon,
    },
    {
      name: "Knowledge hub trainers",
      path: `/knowledge_hub_user/${id}`,
      icon: HoldersIcon,
    },
    {
      name: "Details",
      path: `/space_detail/${id}`,
      icon: DetailsIcon,
    },
    { name: "Knowledge finetuners", path: ``, icon: FinetureTile },
    {
      name: "Logs",
      path: null,
      icon: LogsIcon,
    },
  ];

  return (
    <MainLayout>
      <SectionHeader back={true} title={"Knowledge hub: Configurations"} />
      <WindowHeightComponent className={""}>
        <div className="All-cards p-3">
          {tiles.map((tile, index) => (
            <div
              key={index}
              onClick={() => handleClick(tile.path)}
              style={{ cursor: tile.path ? "pointer" : "default" }}
            >
              <div className="assigned_tiles_inner activate">
                {tile.icon ? (
                  React.createElement(tile.icon)
                ) : (
                  <div style={{ width: 50, height: 50, background: "#ccc" }} />
                )}
                <div className="tile mt-3">{tile.name}</div>
              </div>
            </div>
          ))}
        </div>
      </WindowHeightComponent>
    </MainLayout>
  );
};

export default SpaceConfig;
